'use strict';

console.log('test1');

window.swal = require('sweetalert2');

import angular from 'angular';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import 'angular-socket-io';
import ngAnimate from 'angular-animate';

import uiRouter from 'angular-ui-router';
import 'angular-ui-router/release/stateEvents';
import uiBootstrap from 'angular-ui-bootstrap';
import 'angular-ui-ace';
import 'ui-select';
import ngFileUpload from 'ng-file-upload';
import '../touch';
import 'angular-validation-match';
import 'angular-loading-bar';
import 'angular-translate';
import 'angular-translate-storage-local';
import 'angular-translate-storage-cookie';
import 'angular-translate-loader-static-files';

import './user-agent';

import emojione from 'emojione';
emojione.emojiSize = 128;

import { routeConfig } from './app.config';

import _Auth from '../components/auth/auth.module';
import modal from '../components/modal/modal.service';

import containersShow from './containersShow/containersShow.controller';

import constants from './app.constants';
import util from '../components/util/util.module';
import socket from '../components/socket/socket.service';
import Container from '../components/container/container.service';

import wmwindow from './wmwindow.directive/wmwindow.directive.directive';
import wmView from './wmView.directive/wmView.directive.directive';
import ttyView from './ttyview.directive/ttyview.directive.directive';

import modalContainerSaveFile from './modalContainerSaveFile/modalContainerSaveFile.controller';

import GaService from '../components/ga/ga.service';

import './app.scss';

angular.module('paizacloudApp', [ngCookies, ngResource, ngSanitize, 'btford.socket-io', uiRouter,
  uiBootstrap, _Auth, constants, socket, util, Container,

  modal,

  ngAnimate,

  ngFileUpload,
  'validation.match',
  containersShow,

  wmwindow,
  wmView,
  ttyView,

  modalContainerSaveFile,

  GaService,

  'angular-loading-bar',
  'pascalprecht.translate',

  'ui.ace',
  'ui.select',
])
  .config(routeConfig)
  .run(function($rootScope, $location, $state, Auth) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in

    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      // https://github.com/angular-ui/ui-router/issues/1399#issuecomment-173949193
      // $stateChangeStart to wait for an ajax request (some manual promise to ressolve) without state.go()

      if (fromParams.skipSomeAsync) {
        return;
      }

      Auth.isLoggedIn(function(loggedIn) {
        if (toState.authenticate && !loggedIn) {
          $location.path('/signup');
        }
      });
    });
  })
  .run(function($rootScope, $location, $window) {
    $rootScope.$on('$stateChangeSuccess', (event) => {
      const page = $location.path();
      window.gtag('config', window.ga_ua, { 'optimize_id': window.optimize_id, 'page_path': page });
    });
  })
  .run(function($rootScope, $window) {
    $rootScope.isMobile = $window.isMobile;
  })
  .config(($uibTooltipProvider) => {
    $uibTooltipProvider.options({
      appendToBody: true,
      trigger: window.isIOS ? 'none' : 'mouseenter',
    });
  })
  // http://www.buildinsider.net/web/angularjstips/0041
  .config(['$cookiesProvider', function($cookiesProvider) {
    let expire = new Date();
    expire.setFullYear(expire.getFullYear() + 10);
    $cookiesProvider.defaults.expires = expire;
    $cookiesProvider.defaults.path = '/';
  }])
  // https://gist.github.com/mlynch/dd407b93ed288d499778
  // https://stackoverflow.com/questions/14833326/how-to-set-focus-on-input-field/44561863#44561863
  .directive('autofocus', ($timeout) => ({ link: (_, e) => $timeout(() => e[0].focus()) }))
  .directive('autoselect', ($timeout) => ({ link: (_, e) => $timeout(() => e[0].select()) }))
  .directive('spinner', () => ({ template: '<i class="fa fa-spinner fa-spin"></i>' }))
  .directive('spinnerFill', () => ({
    transclude: true,
    template:
      '<div style="display: flex; align-items: center; justify-content:center; position:absolute; top:0; left:0; width:100%; height:100%; z-index:1; background-color: lightgray; opacity: 0.5;font-size: xx-large;">\n' +
      '    <spinner></spinner><div ng-transclude></div>\n' +
      '</div>\n'
  }))
  .directive('emojione', () => ({ link: (_, e) => e.html(emojione.toImage(e.html())) }))
  .filter('emojione', () => ((input) => emojione.toImage(input)))
  .directive("ngTouchstart", () => ({
    // https://github.com/nglar/ngTouch/blob/master/src/ngTouch.js
    // https://github.com/nglar/ngTouchstart/blob/master/src/ngTouchstart.js
    link: (scope, element, attrs) => {
      element.on('touchstart', (event) => {
        const method = element.attr("ng-touchstart");
        scope.$event = event;
        scope.$apply(method);
      });
    }
  }))
  .directive("ngMousedownTouchstart", () => ({
    // https://github.com/nglar/ngTouch/blob/master/src/ngTouch.js
    // https://github.com/nglar/ngTouchstart/blob/master/src/ngTouchstart.js
    link: (scope, element, attrs) => {
      element.on('mousedown touchstart', (event) => {
        const method = element.attr("ng-mousedown-touchstart");
        scope.$event = event;
        scope.$apply(method);
      });
    }
  }))
  .directive("ngMiddleClick", () => ({
    link: (scope, element, attrs) => {
      element.on('mousedown', (event) => {
        if (event.button === 1) {
          scope.$event = event;
          const method = element.attr("ng-middle-click");
          scope.$apply(method);
        }
      });
    }
  }))
  .directive("ngDoubleTap", () => ({
    link: (scope, element, attrs) => {
      let lastTouchEndTime = 0;
      element.on('touchend', (event) => {
        const now = new Date().getTime();
        if (now - lastTouchEndTime <= 350) {
          const method = element.attr("ng-double-tap");
          scope.$event = event;
          scope.$apply(method);
        }
        lastTouchEndTime = now;
      });
    }
  }))
  .directive("ngLongTouch", () => ({
    link: (scope, element, attrs) => {
      let touchStartClearTimeout;
      element.on('touchstart', (event) => {
        const now = new Date().getTime();
        touchStartClearTimeout = setTimeout(() => {
          scope.$apply(() => {
            const method = element.attr("ng-long-touch");
            scope.$event = event;
            scope.$apply(method);
          });
        }, 1000);
      });
      element.on('touchend', (event) => {
        if (touchStartClearTimeout) {
          touchStartClearTimeout();
        }
      });
    }
  }))
  .factory("openApplicationMenu", ($timeout) => {
    return (scope, dropdownMenuElementSelector, domEvent) => {
      console.log('showApplicationMenu', event);
      if (!scope.contextmenu.opened) {
        $timeout(() => {
          scope.contextmenu.opened = true;
          $timeout(() => {
            const dropdownMenuElement = $(dropdownMenuElementSelector);
            const top = domEvent.pageY;
            const left = domEvent.pageX;
            dropdownMenuElement.css({ top, left });
          });

          function ignoreEvent(event) {
            event.preventDefault();
            event.stopPropagation();
          }
          scope.$watch('contextmenu.opened', (post, pre) => {
            if (scope.contextmenu.opened) {
              return;
            }
            ['mousedown', 'touchstart'].forEach((event) => {
              window.removeEventListener(event, ignoreEvent, true);
            });
          });
          scope.$on('$destroy', () => {
            ['mousedown', 'touchstart'].forEach((event) => {
              window.removeEventListener(event, ignoreEvent, true);
            });
          });
          ['mousedown', 'touchstart'].forEach((event) => {
            window.addEventListener(event, ignoreEvent, true);
          });

        });
      }
    };
  })
  .directive("en", ($translate, $rootScope) => ({
    restrict: "EAC",
    link: (_, e) => {
      e.toggle($translate.use() === 'en');
      $rootScope.$on('$translateChangeSuccess', () => {
        e.toggle($translate.use() === 'en');
      });
    },
  }))
  .directive("ja", ($translate, $rootScope) => ({
    restrict: "EAC",
    link: (_, e) => {
      e.toggle($translate.use() === 'ja');
      $rootScope.$on('$translateChangeSuccess', () => {
        e.toggle($translate.use() === 'ja');
      });
    },
  }))
  .directive("checkmark", () => ({
    restrict: "EAC",
    template: '<i class="glyphicon glyphicon-ok"></i>',
  }))
  .directive("ngVisible", () => ({
    restrict: "A",
    link: (scope, element, attrs) => {
      scope.$watch(attrs.ngVisible, (value) => {
        element.css('visibility', value ? 'visible' : 'hidden');
      });
    }
  }))
  .factory('$swal', ($q) => {
    return (...args) => $q.when(window.swal(...args));
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['paizacloudApp'], {
      // strictDi: true
      strictDi: false
    });
  });

require('./containerMenu.directive/containerMenu.directive.directive');
require('./containerwm.directive/containerwm.directive.directive');
require('./sidebar.directive/sidebar.directive.directive');
require('./fileTree.directive/fileTree.directive.directive');
require('./flex-split-pane-divider/flex-split-pane-divider.directive');
require('./flex-split-pane-divider/flex-split-pane-divider.directive');

require('./browserview.directive/browserview.directive.directive');
require('./containerSplitPane/containerSplitPane.directive');
require('./containerTabwm.directive/containerTabwm.directive.directive');
require('./draggable/draggable.directive');
require('./editorview.directive/editorview.directive.directive');
require('./languages/languages.service');
require('./modalFileUpload/modalFileUpload.controller');
require('./sortableTab.directive/sortableTab.directive.directive');
require('./tree.directive/tree.directive.directive');
require('./wmtab.directive/wmtab.directive.directive');

require('./translate');
